import makeStyles from '@mui/styles/makeStyles';
import { BREAKPOINTS, COLORS, FONT_20, HEIGHT_SIZE, PAGE_STYLES, Z_INDEX } from 'constants/styles';

const menuLabelStyle = {
  ...FONT_20,
  fontWeight: 500,
  color: COLORS.text,
};

export default makeStyles(
  {
    root: {
      position: 'fixed',
      width: '100%',
      height: HEIGHT_SIZE.header,
      zIndex: Z_INDEX.header,
    },
    background: {
      zIndex: -1,
      height: '100%',
      width: '100%',
      position: 'absolute',
      backgroundColor: '#ffffff',
    },
    logo: {
      display: 'block',

      [`@media (max-width:${BREAKPOINTS.MD}px)`]: {
        display: 'none',
      }
    },
    header: {
      height: '100%',
      display: 'flex',
      alignItems: 'center',
      ...PAGE_STYLES,
    },
    menu: {
      display: 'flex',
      alignItems: 'center',
      marginLeft: 60,
      color: COLORS.text,

      '& > * + *': {
        marginLeft: 60,
      },

      [`@media (max-width:${BREAKPOINTS.MD}px)`]: {
        flex: 1,
        justifyContent: 'space-between',

        '& > * + *': {
          margin: 'initial',
        },
      },
    },
    menuAdditional: {
      marginLeft: 'auto',

      [`@media (max-width:${BREAKPOINTS.MD}px)`]: {
        margin: 'initial',
      }
    },
    menuItem: {
      ...menuLabelStyle,
    },
    contactSalesButton: {
      ...FONT_20,
      fontWeight: 500,
      color: COLORS.text,
      border: 0,
      cursor: 'pointer',
    },
  },
  { name: 'Header' },
);
